import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createAuthorisedPickup, createCurriculum, createEmergencyContact, createMeal, createUnauthorisedPickup, deleteCurriculum, fetchAuthorisedPickup, fetchCurriculumCategory, fetchCurriculumPlan, fetchEmergencyContact, fetchUnauthorisedPickup, removeAuthorisedPickup, removeEmergencyContact, removeUnauthorisedPickup, updateAuthorisedPickup, updateCurriculum, updateEmergencyContact, updateStatusCurriculum, updateUnauthorisedPickup } from "../../../service/api";


export const getUnauthorisedPickup = createAsyncThunk(
    "unauthorised/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchUnauthorisedPickup(params)
            console.log("un authorised contact", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const addUnauthorisedPickup = createAsyncThunk(
    "unauthorised/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createUnauthorisedPickup(formValue)
            if (response.status === 201) {
                console.log("unauthorised", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editUnauthorisedPickup = createAsyncThunk(
    "unauthorised/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateUnauthorisedPickup(formValue)
            if (response.status === 201) {
                console.log("edit un authorised", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const deleteUnauthorisedPickup = createAsyncThunk(
    "unauthorised/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await removeUnauthorisedPickup(formValue)
            if (response.status === 201) {
                console.log("delete authorised pickup", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const unauthorisedSlice = createSlice({
    name: "unauthorisedPickup",
    initialState: {
        unauthorisedList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        searchParams: "",

    },
    reducers: {

        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },

    },

    extraReducers: (builder) => {
        builder
            //GET
            .addCase(getUnauthorisedPickup.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getUnauthorisedPickup.fulfilled, (state, action) => {
                state.isLoading = false;
                state.unauthorisedList = action.payload.data;
            })

            .addCase(getUnauthorisedPickup.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // POST
            .addCase(addUnauthorisedPickup.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addUnauthorisedPickup.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addUnauthorisedPickup.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // PUT
            .addCase(editUnauthorisedPickup.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editUnauthorisedPickup.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editUnauthorisedPickup.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // delete
            .addCase(deleteUnauthorisedPickup.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteUnauthorisedPickup.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteUnauthorisedPickup.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams } = unauthorisedSlice.actions;

export default unauthorisedSlice.reducer;
